import { configureStore } from '@reduxjs/toolkit'
import { authApi } from './api/authApi'
import { dashboardApi } from './api/dashboardApi'
import { usersApi } from './api/usersApi'
import { billingApi } from './api/billingApi'
import { organizationsApi } from './api/organizationsApi'
import { projectsApi } from './api/projectsApi'
import { membersApi } from './api/membersApi'
import { invitationsApi } from './api/invitationsApi'
import { discountCodesApi } from './api/discountCodesApi'
import { queueMonitoringApi } from './api/queueMonitoringApi'
import { notificationsApi } from './api/notificationsApi'
import { expansionDeliverablesApi } from './api/expansionDeliverablesApi'
import { guestToursApi } from './api/guestToursApi'
import { onboardingApi } from './api/onboardingApi'
import { trialAnalyticsApi } from './api/trialAnalyticsApi'
import { checkAnalyticsApi } from './api/checkAnalyticsApi'
import { motiocompAnalyticsApi } from './api/motiocompAnalyticsApi'
import { databaseApi } from './api/databaseApi'
import { integrationsApi } from './api/integrationsApi'
import { sowPrdApi } from './api/sowPrdApi'
import { clientProposalsApi } from './api/clientProposalsApi'
import { devHandoffsApi } from './api/devHandoffsApi'
import { aiScoutApi } from './api/aiScoutApi'
import { motionodeAiApi } from './api/motionodeAiApi'
import { modelPerformanceApi } from './api/modelPerformanceApi'
import { moEvalsApi } from './api/moEvalsApi'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    [authApi.reducerPath]: authApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [membersApi.reducerPath]: membersApi.reducer,
    [invitationsApi.reducerPath]: invitationsApi.reducer,
    [discountCodesApi.reducerPath]: discountCodesApi.reducer,
    [queueMonitoringApi.reducerPath]: queueMonitoringApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [expansionDeliverablesApi.reducerPath]: expansionDeliverablesApi.reducer,
    [guestToursApi.reducerPath]: guestToursApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [trialAnalyticsApi.reducerPath]: trialAnalyticsApi.reducer,
    [checkAnalyticsApi.reducerPath]: checkAnalyticsApi.reducer,
    [motiocompAnalyticsApi.reducerPath]: motiocompAnalyticsApi.reducer,
    [databaseApi.reducerPath]: databaseApi.reducer,
    [integrationsApi.reducerPath]: integrationsApi.reducer,
    [sowPrdApi.reducerPath]: sowPrdApi.reducer,
    [clientProposalsApi.reducerPath]: clientProposalsApi.reducer,
    [devHandoffsApi.reducerPath]: devHandoffsApi.reducer,
    [aiScoutApi.reducerPath]: aiScoutApi.reducer,
    [motionodeAiApi.reducerPath]: motionodeAiApi.reducer,
    [modelPerformanceApi.reducerPath]: modelPerformanceApi.reducer,
    [moEvalsApi.reducerPath]: moEvalsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      dashboardApi.middleware,
      usersApi.middleware,
      billingApi.middleware,
      organizationsApi.middleware,
      projectsApi.middleware,
      membersApi.middleware,
      invitationsApi.middleware,
      discountCodesApi.middleware,
      queueMonitoringApi.middleware,
      notificationsApi.middleware,
      expansionDeliverablesApi.middleware,
      guestToursApi.middleware,
      onboardingApi.middleware,
      trialAnalyticsApi.middleware,
      checkAnalyticsApi.middleware,
      motiocompAnalyticsApi.middleware,
      databaseApi.middleware,
      integrationsApi.middleware,
      sowPrdApi.middleware,
      clientProposalsApi.middleware,
      devHandoffsApi.middleware,
      aiScoutApi.middleware,
      motionodeAiApi.middleware,
      modelPerformanceApi.middleware,
      moEvalsApi.middleware,
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch 